import BaseStore from 'core/stores/BaseStore';
import { MultiPackageProductService } from 'common/data';

class MultiPackageProductStore extends BaseStore {
	constructor(rootStore) {
		super(new MultiPackageProductService(rootStore.app.baasic.apiClient));
	}
}

export default MultiPackageProductStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/MultiPackageProductStore.js